import { takeEvery, put, select, call } from 'redux-saga/effects';
import 'whatwg-fetch';
import * as actionTypes from 'constants/actionTypes';
import { trackEvent } from 'actions/events';
import { selectAccountUserEvent } from 'reducers/account/userEvents';
import { createUserEventInFirebase } from 'sagas/account/userEvents';

/*
 * Applies the specified changes to the segment in `account/event-names`
 * reducer, then persists the new value to Firebase
 *
 * @param action
 */

function* updateUserEventAndFlushUserEvent(action) {
  const { eventId, changes } = action.payload;

  const userEvent = yield select(selectAccountUserEvent, eventId);

  if (userEvent.source === 'api') {
    yield call(createUserEventInFirebase, {
      ...userEvent,
      ...changes,
      source: 'firebase',
    });
  } else {
    yield put({
      type: actionTypes.UPDATE_USER_EVENT_IN_STORE,
      payload: {
        eventId,
        changes,
      },
    });

    yield put({
      type: actionTypes.FLUSH_USER_EVENT_TO_FIREBASE,
      payload: {
        eventId,
      },
    });
  }

  yield put(
    trackEvent('Updated a userEvent', {
      event_id: eventId,
    })
  );
}

function* userEvents() {
  yield takeEvery(
    actionTypes.UPDATE_USER_EVENT_AND_FLUSH_USER_EVENT,
    updateUserEventAndFlushUserEvent
  );
}

export default userEvents;
